import { FiShoppingCart } from "react-icons/fi";
import { handleWhatappMessage } from "../../../hooks/common";

import styles from "./index.module.css";

function Button({ children, variant, className, ...rest }) {
  const variantStyle = styles.hasOwnProperty(variant) ? styles[variant] : null;
  return (
    <button
      className={[styles.button, variantStyle, className].join(" ")}
      {...rest}
    >
      {children}
    </button>
  );
}

export default Button;

export function ButtonHref({
  children,
  href,
  variant,
  target = "_self",
  className,
  title = "",
  message = "",
  price = "",
  ...rest
}) {
  return (
    <button
      className={[styles.button, variant, className].join(" ")}
      onClick={() =>
        handleWhatappMessage({
          name: title,
          description: message,
          price: price,
        })
      }
      href={href}
      target={target}
      rel={target === "_blank" ? "noreferrer" : undefined}
      {...rest}
    >
      {children}
    </button>
  );
}

export function WhatsAppButton({
  children,
  href = "#",
  variant = "primary",
  target = "_self",
  className = "",
  title = "",
  message = "",
  price = "",
}) {
  return (
    <button
      className={`btn btn-${variant} ${className}`}
      onClick={() =>
        handleWhatappMessage({
          name: title,
          description: message,
          price: price,
        })
      }
      href={href}
      target={target}
      rel={target === "_blank" ? "noreferrer" : undefined}
    >
      {children}
    </button>
  );
}
